export default __webpack_public_path__ + "static/logo-e45bde35a8ddc68c9298937d204fdfee.webp";